import { db, doc, getDoc } from '../firebase';

// Default app version - this should match your package.json version
export const DEFAULT_APP_VERSION = '1.2.0';

/**
 * Gets the current app version from local constants
 * @returns {Promise<string>} The current app version string
 */
export const getCurrentAppVersion = async () => {
  // Return the local app version - this should match package.json
  // Users need to download a new APK to get a new version
  return DEFAULT_APP_VERSION;
};

/**
 * Fetches the required version from Firestore
 * This is the minimum version users must have to use the app
 * @returns {Promise<string>} The required version string
 */
export const getRequiredVersion = async () => {
  try {
    const configDoc = doc(db, 'config', 'app');
    const configSnapshot = await getDoc(configDoc);
    
    if (configSnapshot.exists()) {
      const data = configSnapshot.data();
      return data.requiredVersion || DEFAULT_APP_VERSION;
    }
    
    // If no config document exists, return default version as fallback
    console.warn('No app config found in Firestore, using default version as required');
    return DEFAULT_APP_VERSION;
  } catch (error) {
    console.error('Error fetching required version:', error);
    // Return default version as fallback to prevent app from being blocked
    return DEFAULT_APP_VERSION;
  }
};

/**
 * Compares two version strings
 * @param {string} currentVersion - Current app version
 * @param {string} requiredVersion - Required version from server
 * @returns {boolean} True if current version is outdated
 */
export const isVersionOutdated = (currentVersion, requiredVersion) => {
  const current = currentVersion.split('.').map(Number);
  const required = requiredVersion.split('.').map(Number);
  
  for (let i = 0; i < Math.max(current.length, required.length); i++) {
    const currentPart = current[i] || 0;
    const requiredPart = required[i] || 0;
    
    if (currentPart < requiredPart) {
      return true; // Current version is outdated
    } else if (currentPart > requiredPart) {
      return false; // Current version is newer
    }
  }
  
  return false; // Versions are equal
};

// Test function to verify version comparison
export const testVersionComparison = () => {
  console.log('Testing version comparison:');
  console.log('1.0.0 vs 999.999.999:', isVersionOutdated('1.0.0', '999.999.999')); // Should be true
  console.log('1.0.0 vs 1.0.0:', isVersionOutdated('1.0.0', '1.0.0')); // Should be false
  console.log('1.1.0 vs 1.0.0:', isVersionOutdated('1.1.0', '1.0.0')); // Should be false
  console.log('1.0.0 vs 1.1.0:', isVersionOutdated('1.0.0', '1.1.0')); // Should be true
}; 